import { Link } from 'react-router-dom';
import { getHotArticles } from '@/mocks/articles';
import { getCategoryBySlug } from '@/mocks/categories';

export default function HotTopics() {
  const hot = getHotArticles();

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-900 mb-3">
              热门话题
            </h2>
            <p className="text-foreground-600 text-base">社区最受关注的技术话题和讨论</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {hot.map((article, index) => {
            const cat = getCategoryBySlug(article.category);
            return (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-300 p-5 md:p-6 relative overflow-hidden"
              >
                <div className="absolute top-0 right-0 w-16 h-16 flex items-start justify-end pt-2 pr-3">
                  <span className="text-4xl font-bold text-primary-100 font-heading">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                </div>
                <div className="relative z-10">
                  <div className="flex items-center gap-2.5 mb-3">
                    <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                      热门
                    </span>
                    <span className="text-xs text-foreground-500">{cat?.name}</span>
                  </div>
                  <h3 className="text-base font-bold font-heading text-foreground-900 mb-3 group-hover:text-primary-600 transition-colors line-clamp-2 pr-12">
                    {article.title}
                  </h3>
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-eye-line"></i> {article.viewCount.toLocaleString()}
                    </span>
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-chat-3-line"></i> {article.commentCount}
                    </span>
                    <span className="whitespace-nowrap">{article.publishDate}</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}